import { useToast as useVueToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// Global debouncing for all toast notifications
const recentToasts = new Map();
const DEBOUNCE_TIME = 3000; // 3 seconds

const shouldShowToast = (type, message) => {
  const key = `${type}-${message}`;
  const now = Date.now();
  const lastShown = recentToasts.get(key);
  
  // Show if it's a new message or enough time has passed
  if (!lastShown || (now - lastShown) >= DEBOUNCE_TIME) {
    recentToasts.set(key, now);
    return true;
  }
  
  return false;
};

// Clean up old entries periodically to prevent memory leaks
setInterval(() => {
  const now = Date.now();
  for (const [key, timestamp] of recentToasts.entries()) {
    if (now - timestamp > DEBOUNCE_TIME * 2) {
      recentToasts.delete(key);
    }
  }
}, DEBOUNCE_TIME * 2);

export const useToast = () => {
  const toast = useVueToast();

  return {
    success: (message, options = {}) => {
      const mergedOptions = {
        timeout: 3000,
        position: 'top-right',
        ...options
      };
      
      if (shouldShowToast('success', message)) {
        return toast.success(message, mergedOptions);
      }
    },
    error: (message, options = {}) => {
      const mergedOptions = {
        timeout: 5000,
        position: 'top-right',
        ...options
      };
      
      if (shouldShowToast('error', message)) {
        return toast.error(message, mergedOptions);
      }
    },
    warning: (message, options = {}) => {
      const mergedOptions = {
        timeout: 4000,
        position: 'top-right',
        ...options
      };
      
      if (shouldShowToast('warning', message)) {
        return toast.warning(message, mergedOptions);
      }
    },
    info: (message, options = {}) => {
      const mergedOptions = {
        timeout: 3000,
        position: 'top-right',
        ...options
      };
      
      if (shouldShowToast('info', message)) {
        return toast.info(message, mergedOptions);
      }
    },
    dismiss: (id) => {
      return toast.dismiss(id);
    },
    clear: () => {
      return toast.clear();
    }
  };
};